/*
 * Collection featured item — hover quick-add alignment.
 *
 * The featured PLP item (.collection-grid-featured__item) renders its image at
 * aspect-ratio: auto (landscape), but the absolutely-positioned hover quick-add
 * wrapper sizes itself with aspect-ratio: var(--media-ratio) (0.75), so its box
 * overshoots the image and the size pills land over the title/price.
 *
 * CSS can't read the image's dynamic height reliably (it varies with a 1- or
 * 2-line title) across browsers, so we measure the media box here and publish
 * it as --pc-featured-media-h on the card. collection.css anchors the wrapper
 * height to that variable. Only runs at >=990px, where the desktop hover
 * quick-add appears.
 */
(() => {
  const DESKTOP = window.matchMedia('(min-width: 990px)');

  const updateCard = (card) => {
    const media = card.querySelector('.product-card__media');
    if (!media) return;

    if (DESKTOP.matches) {
      card.style.setProperty('--pc-featured-media-h', `${media.offsetHeight}px`);
    } else {
      card.style.removeProperty('--pc-featured-media-h');
    }
  };

  const cards = () =>
    document.querySelectorAll('.collection-grid-featured__item .product-card');

  const updateAll = () => cards().forEach(updateCard);

  // Re-measure when the media box resizes (layout shifts, image load, viewport).
  const ro =
    'ResizeObserver' in window
      ? new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            const card = entry.target.closest(
              '.collection-grid-featured__item .product-card'
            );
            if (card) updateCard(card);
          });
        })
      : null;

  const observe = () => {
    if (!ro) return;
    cards().forEach((card) => {
      const media = card.querySelector('.product-card__media');
      if (media) ro.observe(media);
    });
  };

  const init = () => {
    updateAll();
    observe();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The PLP can swap grid markup (infinite scroll / restore); re-init on change.
  const grid = document.querySelector('collection-grid');
  if (grid && 'MutationObserver' in window) {
    new MutationObserver(() => init()).observe(grid, {
      childList: true,
      subtree: true,
    });
  }

  window.addEventListener('resize', updateAll);
  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', updateAll);
})();
